// web/src/App.tsx
import { useEffect, useState } from "react";

import { BAD_RESPONSE, call, type Me, NETWORK_ERROR } from "./lib/api";
import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { Stock } from "./pages/Stock";

export function App() {
  const [me, setMe] = useState<Me | null>(null);
  const [ready, setReady] = useState(false);
  // Отдельно от «не вошёл»: до сервера не достучались вовсе (сеть, дев-прокси
  // смотрит не туда, бэкенд не поднят) — форма входа здесь была бы обманом,
  // человек ввёл бы пароль в пустоту.
  const [offline, setOffline] = useState(false);

  // Спрашиваем «кто я» на старте: cookie httpOnly, из JS её не видно, и
  // единственный способ узнать, жива ли сессия, — спросить сервер.
  // `call()` сама не бросает исключений (см. api.ts), но `.catch()` и
  // `.finally()` — подстраховка на случай неожиданного сбоя в самом
  // обработчике: `ready` обязан стать `true` при любом исходе, иначе экран
  // останется пустым навсегда, неотличимо от «просто медленно грузится».
  useEffect(() => {
    call<Me>("/api/me")
      .then((r) => {
        setMe(r.results);
        const code = r.error[0]?.code;
        setOffline(code === NETWORK_ERROR || code === BAD_RESPONSE);
      })
      .catch(() => setOffline(true))
      .finally(() => setReady(true));
  }, []);

  if (!ready) return null;
  if (offline) {
    return (
      <div className="mx-auto mt-32 w-72 text-[13px] text-fg-faint">
        Не удалось связаться с сервером. Проверьте соединение и обновите
        страницу.
      </div>
    );
  }
  if (!me) return <Login onEnter={setMe} />;

  // Разбор адреса прямо здесь, без клиентского роутера: разделов два, и
  // библиотека маршрутизации ради двух ссылок была бы узлом, который надо
  // помнить и обновлять. Сервер отдаёт index.html на любой не-API путь, так
  // что прямое открытие /stock работает.
  return window.location.pathname === "/stock" ? (
    <Stock me={me} onLeave={() => setMe(null)} />
  ) : (
    <Home me={me} onLeave={() => setMe(null)} />
  );
}
